export interface TBootstrapDeps {
  fetchConfig: () => Promise<void>;
  initResources: () => void;
  renderApp: () => void;
  registerSw: () => void;
}

// Порядок стадий — контракт: registerSw обязан идти после fetchConfig,
// иначе SWRegister читает дефолтный serviceWorkerEnabled=false (F1).
export async function runBootstrap(deps: TBootstrapDeps): Promise<void> {
  await deps.fetchConfig();
  deps.initResources();
  deps.renderApp();
  deps.registerSw();
}
